import { IconNames } from '@blueprintjs/icons';
import { DetailLabelValuePair } from '@strata/react-label-value-pairs';
import { PayerRequestStatusIndicator } from '@strata/react-status-indicators';

import {
    type BasePayerRequestAdditonalData,
    BasePayerRequestNotification,
    type CommonPayerRequestNotificationProps,
} from 'components/notifications/BasePayerRequestNotification';

export interface PayerRequestStatusChangedNotificationProps extends CommonPayerRequestNotificationProps {
    small: boolean;
    additionalData: BasePayerRequestAdditonalData & {
        rawNewRequestStatus: (typeof PayerRequestStatusIndicator.Statuses)[keyof typeof PayerRequestStatusIndicator.Statuses];
    };
}

export const PayerRequestStatusChangedNotification = ({
    linkingId,
    timestamp,
    additionalData,
    onNotificationClick,
    onRemoveNotificationClick,
    status,
    small,
    payerId,
}: PayerRequestStatusChangedNotificationProps) => (
    <BasePayerRequestNotification
        notificationTitle="Request Status Changed"
        icon={IconNames.REFRESH}
        additionalDataComponent={
            <div className="flex__gap--small" style={{ flexDirection: 'column' }}>
                <DetailLabelValuePair
                    label="New Status"
                    value={
                        <PayerRequestStatusIndicator status={additionalData.rawNewRequestStatus} />
                    }
                />
                {!small && (
                    <DetailLabelValuePair
                        label="Request #"
                        value={additionalData.requestNumber?.toString().padStart(6, '0')}
                    />
                )}
            </div>
        }
        additionalData={additionalData}
        linkingId={linkingId}
        onNotificationClick={onNotificationClick}
        onRemoveNotificationClick={onRemoveNotificationClick}
        payerId={payerId}
        status={status}
        timestamp={timestamp}
    />
);
